import React from 'react';
import { Card, Table, Typography, Divider, Alert, Tag } from 'antd';
import { API_BASE_URL } from '../services/api';

const { Title, Text } = Typography;

const PHASE_COLORS = {
  KGS: 'orange',
  'KGS+': 'orange',
  KS: 'gold',
  'KS+': 'gold',
  KV: 'green',
  'KV+': 'green',
  BA: 'blue',
};

const Results = ({ results }) => {
  const formatProjectInfo = (info) => {
    const fields = [
      { key: 'Objektarten Hauptgruppe', suffix: '' },
      { key: 'Baudatum', suffix: '' },
      { key: 'Geschossfläche', suffix: ' m²' },
      { key: 'Geschossfläche oberirdisch', suffix: ' m²' },
      { key: 'Hauptnutzfläche', suffix: ' m²' },
    ];

    return (
      <>
        {fields.map(field => (
          info[field.key] && (
            <div key={field.key}>
              • {field.key}: {info[field.key]}{field.suffix}
            </div>
          )
        ))}
        {info.anzahl_phasen > 1 && (
          <div>
            • Kostenphasen verfügbar: {info.anzahl_phasen}
          </div>
        )}
        {info.source && (
          <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
            • SharePoint-Speicherort: {info.source.replace(
              '/Users/singhsiddhartha/Projects/perita-kostensuchmaschine/data/',
              ''
            )}
          </div>
        )}
      </>
    );
  };

  const getProjectName = (info) => {
    return info.Projektname || 'Unbekanntes Projekt';
  };

  const getProjectTitle = (info) => (
    <span>
      {getProjectName(info)}
      {info.Phase && (
        <Tag
          color={PHASE_COLORS[info.Phase] || 'default'}
          style={{ marginLeft: 8 }}
        >
          {info.Phase}{info.Genauigkeit ? ` ±${info.Genauigkeit}%` : ''}
        </Tag>
      )}
      {info.Bauart && <Tag style={{ marginLeft: 4 }}>{info.Bauart}</Tag>}
      {info.Variante && <Tag color="purple" style={{ marginLeft: 4 }}>{info.Variante}</Tag>}
      {info.Status && <Tag color="red" style={{ marginLeft: 4 }}>{info.Status}</Tag>}
    </span>
  );

  const projectFoto = (info) => {
    if (!info.foto) return null;
    return (
      <img
        src={`${API_BASE_URL()}/fotos/${encodeURIComponent(info.foto)}`}
        alt={getProjectName(info)}
        style={{
          maxWidth: '220px',
          maxHeight: '160px',
          objectFit: 'cover',
          borderRadius: '6px',
          flexShrink: 0,
        }}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    );
  };

  if (!results) {
    return null;
  }

  if (!results.success) {
    return (
      <Alert
        message="Keine Treffer gefunden"
        description={results.message}
        type="warning"
        showIcon
        style={{ marginTop: '20px' }}
      />
    );
  }

  return (
    <div style={{ marginTop: '40px' }}>
      {/* Cost Summary */}
      {results.cost_summary && (
        <>
          <Title level={3}>Kostenübersicht über alle Projekte</Title>
          <Text>Gefundene Projekte: {results.total_projects}</Text>

          <div style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Table
              dataSource={results.cost_summary.data}
              columns={results.cost_summary.columns.map(col => ({
                title: col,
                dataIndex: col,
                key: col,
                width: 150,
                render: (text) => {
                  // Format numbers with 2 decimal places if they are numbers
                  if (typeof text === 'number') {
                    return text.toFixed(2);
                  }
                  return text;
                }
              }))}
              rowKey={(record, index) => index}
              pagination={false}
              scroll={{
                x: true,
                y: 240  // Show ~5 rows (5 * 48px row height)
              }}
              size="small"  // Smaller row gaps
              className="compact-table"
            />
          </div>
          <Divider />
        </>
      )}

      {/* Individual Project Results */}
      <Title level={3}>Einzelne Projektergebnisse</Title>

      {results.results.map((result, index) => (
        <Card
          key={result.id}
          className="wz-result-card"
          style={{ marginBottom: '30px' }}
          title={getProjectTitle(result.info)}
        >
          {/* Project Info + Foto - displayed immediately without streaming */}
          <div style={{ marginBottom: '20px', display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              {formatProjectInfo(result.info)}
            </div>
            {projectFoto(result.info)}
          </div>

          {/* Project Data Table */}
          <Table
            dataSource={result.data}
            columns={result.columns.map(col => ({
              title: col,
              dataIndex: col,
              key: col,
              width: 150,
              render: (text) => {
                // Format numbers with 2 decimal places if they are numbers
                if (typeof text === 'number') {
                  return text.toFixed(2);
                }
                return text;
              }
            }))}
            rowKey={(record, index) => index}
            pagination={false}
            scroll={{
              x: true,
              y: 240  // Show ~5 rows (5 * 48px row height)
            }}
            size="small"  // Smaller row gaps
            className="compact-table"
          />
        </Card>
      ))}
    </div>
  );
};

export default Results;